import { Routes } from '@angular/router';
import { LoginComponent } from './feature/auth/login.component';
import { SignupComponent } from './feature/auth/signup.component';
import { ForgotPasswordComponent } from './feature/auth/forgot-password.component';
import { RegisterComponent } from './feature/auth/register.component';
import { HomeComponent } from './features/home/home.component';
import { TermsOfUseComponent } from './features/legal/terms-of-use.component';
import { PrivacyPolicyComponent } from './features/legal/privacy-policy.component';
import { AccessibilityComponent } from './features/legal/accessibility.component';
import { authGuard } from './core/auth/auth.guard';

export const routes: Routes = [
  {
    path: '',
    component: LoginComponent
  },
  {
    path: 'signup',
    component: SignupComponent
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent
  },
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [authGuard]
  },
  {
    path: 'register',
    component: RegisterComponent,
    canActivate: [authGuard]
  },
  {
    path: 'terms-of-use',
    component: TermsOfUseComponent
  },
  {
    path: 'privacy-policy',
    component: PrivacyPolicyComponent
  },
  {
    path: 'accessibility',
    component: AccessibilityComponent
  },
  {
    path: '**',
    redirectTo: ''
  }
];
